import React from 'react';
import './loading-spinner.css';

// Shared "this is loading, not broken" indicator for in-screen fetches
// (DashboardScreen's stats fetch, BlastAnswerScreen, etc.) so every
// blank-while-fetching spot shows the same thing instead of an empty div
// that looks identical to something having silently broken. Not used for
// the app's boot/auth sequence — that's AppLoadingScreen, which carries
// the graphic + title through App.jsx's init gate, ProtectedRoute's auth
// check, and LoginScreen so there's no jump to a bare spinner mid-boot.
// fullHeight (default true) makes the wrap stretch to fill its parent and
// center within that — right for screens where this is the only thing on
// screen. Pass false when nesting this alongside a sibling (e.g. a Retry
// button below it) so it only takes the space its own content needs,
// letting the parent container handle the actual centering instead.
export const LoadingSpinner = ({ label = null, fullHeight = true }) => {
  return (
    <div className={`loading-spinner-wrap${fullHeight ? '' : ' loading-spinner-wrap--inline'}`}>
      <div className="loading-spinner-ring" aria-hidden="true" />
      {label && <span className="loading-spinner-text">{label}</span>}
    </div>
  );
};

export default LoadingSpinner;
